export function addArrayToParams(paramName: string, array: string[], url: URL) {
	array.forEach((item) => {
		url.searchParams.append(paramName, item);
	});

	return url;
}
